// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"f03194d2","423":"d016b0cd","537":"9a550532"}[chunkId] + ".chunk.css";
};